import axios from "axios";
import router from "@/router/index.js";
import eventBus from "@/util/EventBus.js";

import enquire from "enquire.js";

let URLBASE = "/produccion/rest";

// Add a request interceptor
axios.interceptors.request.use(
  function (config) {
    config.baseURL = URLBASE;
    config.headers["Auth-token"] = getToken();
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axios.interceptors.response.use(
  function (response) {
    // if (response.data.codigo == 1000) {
    //   // sesion ha caducado
    //   console.log("Axios interceptors login. Codigo 1000");
    //   router.push({ path: "/login" });
    // }
    if (response.data.codigo == 1200) {
      // sesion ha caducado
      //eslint-disable-next-line no-console
      console.log("Axios interceptors login. Codigo 1200");
      eventBus.$emit("sesion-caducada");
      router.replace({
        name: "login",
      });
    }

    if (response.data.codigo == 1300) {
      // sesion ha caducado

      //eslint-disable-next-line no-console
      console.log("Axios interceptors login. Codigo 1300");
      router.replace({
        name: "login",
      });
    }

    if (response.data.codigo == 1111) {
      eventBus.$emit(
        "error-comunicacion-servidor",
        "Error de comunicación con servidor"
      );
    }
    if (response.data.data && response.data.data.token) {
      setToken(response.data.data.token);
    }
    return response;
  },
  function (error) {
    eventBus.$emit(
      "error-comunicacion-servidor",
      "Error de comunicación con servidor"
    );
    return Promise.reject(error);
  }
);

function getToken() {
  let token = sessionStorage.getItem("token");
  return token ? token : "no-token";
}

function setToken(token) {
  sessionStorage.setItem("token", token);
}

export default {
  logout: function () {
    setToken("no-token");
    router.push({
      name: "login",
    });
  },

  login: async function (context, cred) {
    let response = await axios.post("/v1/ac/user/auth", {
      username: cred.usuario,
      password: cred.password,
    });
    return response.data;
  },


  loginRegistro: async function (context) {
    let response = await axios.post("/v1/ac/user/authRegistro");

    context.commit("SET_REGISTRO_INFO", response.data.data);
    return response.data;
  },

  verificaUsuario: async function (context, numDoc) {
    let response = await axios.post("/v1/ac/user/verificaUsuario", {
      numDoc: numDoc,
    });
    context.commit("SET_REGISTRO_INFO", response.data.data);
    return response.data;
  },

  mandarPin: async function () {
    let response = await axios.post("/v1/ac/user/generarPinAcceso");
    return response.data;
  },

  verificarPin: async function (context, bean) {
    let response = await axios.post("/v1/ac/user/verificarPin", bean);
    return response.data;
  },

  actualizarPassword: async function (context, bean) {
    let response = await axios.post("/v1/ac/user/actualizarPassword", {
      password: bean.clave1,
      passwordRepetida: bean.clave2,
    });
    return response.data;
  },

  actualizaGdpr: async function (context, bean) {
    console.log(bean);
    let response = await axios.post("/v1/ac/user/actualizarGdpr", {
      gdprEmpresas: bean.gdprEmpresas,
    });
    return response.data;
  },

  asignaPolizaCuponAmigo: async function (context, bean) {
    let response = await axios.post("/v1/ac/user/asignaPolCuponAmigo", {
      idPoliza: bean.idPoliza,
      idCupon: bean.idCupon,
      cupon: bean.cupon,
    });
    return response.data;
  },

  insertAudit: function (context, bean) {
    // eslint-disable-next-line
    console.log(
      "insert audit: " +
      bean.idCliente +
      " " +
      bean.nif +
      " " +
      bean.nameEvento +
      " " +
      bean.info
    );
    axios.post("/v1/ac/user/insertAudit", {
      idCliente: bean.idCliente,
      nif: bean.nif,
      nameEvento: bean.nameEvento,
      info: bean.info,
    });
  },

  actualizarPasswordCliente: async function (context, bean) {
    let response = await axios.post("/v1/ac/user/actualizarPasswordCliente", {
      password: bean.clave1,
      passwordRepetida: bean.clave2,
    });
    return response.data;
  },

  actualizarTelefono: async function (context, bean) {
    let response = await axios.post("/v1/ac/cliente/actualizaTelefono", {
      telefono: bean.telefono,
      polizas: bean.polizas,
    });
    return response.data;
  },

  actualizarEmail: async function (context, bean) {
    let response = await axios.post("/v1/ac/cliente/actualizaEmail", {
      email: bean.email,
      polizas: bean.polizas,
    });
    return response.data;
  },

  creaGestionClienteLlamame: async function (context, bean) {
    let response = await axios.post("/v1/ac/cliente/creaGestionCliente", {
      telefono: bean.telefonoContacto,
      asunto: bean.asunto,
      idWorkerPropio: bean.idWorkerPropio,
      idOwnerPropio: bean.idOwnerPropio,
    });
    return response.data;
  },

  registraParticipacionSorteoTv: async function () {
    let response = await axios.post(
      "/v1/ac/cliente/registraParticipacionSorteoTv"
    );
    return response.data;
  },

  registraParticipacionSorteoDecesosPremium: async function () {
    let response = await axios.post(
      "/v1/ac/cliente/registraTarjetaDecesosPremium"
    );
    return response.data;
  },

  registraParticipacionSorteo100EurosViajar: async function () {
    let response = await axios.post(
      "/v1/ac/cliente/registraParticipacionSorteo100EurosViajar"
    );
    return response.data;
  },

  registraParticipacionSorteoFreidoraAire: async function () {
    let response = await axios.post(
      "/v1/ac/cliente/registraParticipacionSorteoFreidoraAire"
    );
    return response.data;
  },


  getPortfolio: async function (context) {
    eventBus.$emit("spinner-on");
    let response = await axios.get("/v1/ac/portfolio");
    eventBus.$emit("spinner-off");
    if (response.data.codigo == 0) {
      context.commit("SET_PORTFOLIO", response.data.data);
      return true;
    }
    return false;
  },

  getPolizaAutos: async function (context, idPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/polizas-veh/" + idPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getPolizaHogar: async function (context, idPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/polizas-hog/" + idPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getPolizaDecesos: async function (context, idPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/polizas-dec/" + idPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getPolizaMovilidad: async function (context, idPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/polizas-mov/" + idPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getPolizaNegocio: async function (context, idPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/polizas-neg/" + idPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getPolizaAccidentes: async function (context, idPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/polizas-acc/" + idPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getPolizaMascotas: async function (context, idPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/polizas-masc/" + idPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getSiniestroVeh: async function (context, numSiniestro) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/siniestros-veh/" + numSiniestro);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getSiniestroHogar: async function (context, numSiniestro) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/siniestros-hog/" + numSiniestro);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getSiniestroMovilidad: async function (context, numSiniestro) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/siniestros-mov/" + numSiniestro);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getSiniestroNegocio: async function (context, numSiniestro) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/siniestros-neg/" + numSiniestro);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getSiniestroAccidentes: async function (context, numSiniestro) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/siniestros-acc/" + numSiniestro);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getSiniestroMascotas: async function (context, numSiniestro) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/siniestros-masc/" + numSiniestro);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getRecibo: async function (context, idRecibo) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/recibos/" + idRecibo);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getUrlPago: async function (context, idRecibo) {
    eventBus.$emit("spinner-on");
    let response = await axios.get("/v1/ac/recibos/pasarela/pago/" + idRecibo);
    eventBus.$emit("spinner-off");
    return response
  },

  getAvisoRenovacion: async function (context, idPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/avisoRenovacion/" + idPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getDatosCliente: async function (context) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", null);
    let response = await axios.get("/v1/ac/cliente");
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  getUrlClubMMT: async function (context) {
    let response = await axios.get("/v1/ac/getUrlClubMMT");
    context.commit("SET_URLAFFINITY", response.data.data);
  },

  setNuevoTelefono: async function (context, nuevoTelefono) {
    context.commit("SET_NUEVO_TELEFONO", nuevoTelefono);
  },

  setNuevoEmail: async function (context, nuevoEmail) {
    context.commit("SET_NUEVO_EMAIL", nuevoEmail);
  },

  setPolizasSel: async function (context, polizasSel) {
    context.commit("SET_POLIZAS_SEL", polizasSel);
  },

  setupMediaQueries(context) {
    enquire.register("screen and (min-width: 1024px)", {
      match: function () {
        context.commit("SET_DISPLAY_BIGGER_THAN_PHONE", true);
      },
      unmatch: function () {
        context.commit("SET_DISPLAY_BIGGER_THAN_PHONE", true);
      },
    });
  },

  downloadCCPP(context, idPoliza) {
    window.open(URLBASE + "/v1/ac/polizas/ccpp/" + idPoliza + "/" + getToken());
  },

  downloadRecibo(context, idRecibo) {
    console.log("**** DOWNLOAD RECIBO " + idRecibo);
    window.open(
      URLBASE + "/v1/ac/recibos/" + idRecibo + "/imprimir/" + getToken()
    );
  },

  dowloadDocumento(context, uuid) {
    console.log("UUID:" + uuid);
    window.open(
      URLBASE + "/v1/ac/polizas/documento/" + uuid + "/" + getToken()
    );
  },

  downloadCertificadoAseguramientoMascotas(context, numPoliza) {
    console.log("**** downloadCertificadoAseguramientoMascotas" + numPoliza);
    window.open(
      URLBASE + "/v1/ac/polizas-masc/certificado-aseg/" + numPoliza + "/" + getToken()
    );
  },

  openContratosInteractivos: async function () {
    const response = await axios.get("/v1/ac/getUrlContratosInteractivos");
    const url = response.data.data;
    console.log("URL CONTRATOS INTERACTIVOS" + url);
    window.open(url, "_blank");
  },

  getPolizaSalud: async function (context, numPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/polizas-salud/" + numPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },


  getPolizaSaludMMT: async function (context, idPoliza) {
    eventBus.$emit("spinner-on");
    context.commit("SET_SELECCION", {});
    let response = await axios.get("/v1/ac/polizas-saludMMT/" + idPoliza);
    context.commit("SET_SELECCION", response.data.data);
    eventBus.$emit("spinner-off");
  },

  openAreaClienteSaludHna: async function (context, idCliente) {
    const response = await axios.get("/v1/ac/urlHnaAreaCliente/" + idCliente);
    const url = response.data.data;
    console.log("URL HNA SALUD" + url);
    window.open(url, "_blank");
  },


};
